import React from "react";
import { styled, keyframes } from "@mui/system";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import InfoIcon from "@mui/icons-material/Info";
import RefreshIcon from "@mui/icons-material/Refresh";
import FONTS_FAMILY from "../../../theme/FontsFamily";

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.05); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`;

const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "80px 32px", // Tailwind py-20 px-8
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box",
});

const IllustrationContainer = styled("div")({
    position: "relative",
    marginBottom: "24px", // Tailwind mb-6
});

const PulseCircle = styled("div")({
    width: "128px", // Tailwind w-32 (128px)
    height: "128px", // Tailwind h-32 (128px)
    backgroundColor: "#DEE8FF", // Tailwind bg-surface-container-high
    borderRadius: "9999px", // Tailwind rounded-full
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: `${pulse} 3s infinite ease-in-out`,
});

const FolderIconStyled = styled(FolderOpenIcon)({
    fontSize: "60px", // Tailwind text-6xl (60px)
    color: "#C6C5D0", // Tailwind text-outline-variant
});

const InfoBadge = styled("div")({
    position: "absolute",
    bottom: "-8px", // Tailwind -bottom-2
    right: "-8px", // Tailwind -right-2
    width: "40px", // Tailwind w-10 (40px)
    height: "40px", // Tailwind h-10 (40px)
    backgroundColor: "#1A234E", // Tailwind bg-primary-container
    color: "#828BBC", // Tailwind text-on-primary-container
    borderRadius: "9999px", // Tailwind rounded-full
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)", // Tailwind shadow-md
    border: "2px solid #FFFFFF",
});

const Title = styled("h3")({
    fontFamily: FONTS_FAMILY.bold.title,
    fontSize: "32px", // Tailwind headline-md (32px)
    color: "#192873", // Tailwind primary
    margin: "0 0 8px 0", // Tailwind mb-2
    fontWeight: "600",
    lineHeight: "40px",
});

const Subtitle = styled("p")({
    fontFamily: FONTS_FAMILY.regular.body,
    fontSize: "16px", // Tailwind body-md
    color: "#46464F", // Tailwind on-surface-variant
    margin: "0",
    maxWidth: "384px", // Tailwind max-w-sm (384px)
    lineHeight: "24px",
});

const ReloadButton = styled("button")({
    marginTop: "32px", // Tailwind mt-8
    display: "flex",
    alignItems: "center",
    gap: "8px", // Tailwind gap-2
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: "16px",
    color: "#192873", // Tailwind text-primary
    fontWeight: "700",
    transition: "all 0.2s ease",
    "&:hover": {
        textDecoration: "underline", // Tailwind hover:underline
    },
});

function EmptyState({ title = "No se encontraron registros", subtitle = "No existen solicitudes activas que coincidan con sus criterios de búsqueda en este momento.", onRefresh }) {
    return (
        <Container>
            <IllustrationContainer>
                <PulseCircle>
                    <FolderIconStyled />
                </PulseCircle>
                <InfoBadge>
                    <InfoIcon style={{ fontSize: "20px" }} />
                </InfoBadge>
            </IllustrationContainer>

            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>

            {onRefresh && (
                <ReloadButton onClick={onRefresh}>
                    <RefreshIcon style={{ fontSize: "20px" }} /> Actualizar listado
                </ReloadButton>
            )}
        </Container>
    );
}

export default EmptyState;
